import React, { useState, useEffect } from 'react';
import { Loader } from "@progress/kendo-react-indicators";
import api from '../FetchComponents/FetchComponentsServices';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

const UserUpdateHistory = ({osuIdmID}) => {
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [error, setError] = useState('');

    useEffect(async () => {
        if(osuIdmID && osuIdmID.length > 0) {
            var details = await api.GetUserHistory(osuIdmID).then(data => {
                return data
            }).catch(error => {
              console.log(error) // todo add better logging / error handing
            })
            if(!details) {
                setError('Unable to retrieve more details')
            }
            if(details && !details.length) {
                setError('No Details Found')
            }
            if(details && details.length > 0) {
                setDetails(details.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)))
            }
        }
        setLoading(false)
    }, [])

    return (
      <>
        <h2>API Updates</h2>
        {loading && <span><Loader className='spinner-small' size="small" type={"infinite-spinner"} /> Loading Job Details</span>}
        {error.length 
            ? <p>{error}</p>
            :  <div>
                {
                    !loading && <Grid data={details}>
                        <GridColumn width={150} field="actionDone" title="Action"/>
                        <GridColumn field="notes" title="Notes" />
                        <GridColumn width={230} field="createdDate" title="Created Date" format={"{0:G}"} />
                    </Grid>
                }
            </div>
        }
      </>
    );
};

export default UserUpdateHistory;